var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.length)?_c('CButton',{staticClass:"float-right",attrs:{"color":"primary"},on:{"click":_vm.buttonClicked}},[_vm._v(" "+_vm._s(this.$t('download_in_csv'))+" "),_c('CIcon',{attrs:{"name":"cil-cloud-download"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }